import { Client } from "./client";
import { EvidenceItemListResponse } from "@/backend/express/controllers/evidenceItemController";
import { FusaReply } from "@/types/replyTypes";

export class EvidenceItemController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readByProjectId(projectId: string): Promise<EvidenceItemListResponse> {
    return this.client.read(`/api/evidence-items/project/${projectId}`);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/evidence-items/${id}`);
  }
}
